// extracted by mini-css-extract-plugin
export default {"avatar":"ContactAvatar_avatar__iToGC","md":"ContactAvatar_md__kAzgk","chip":"ContactAvatar_chip__z7S+d","sm":"ContactAvatar_sm__xB6Bx"};